/** Shopify CDN: Minification failed

Line 43:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 44:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 44:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 45:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 45:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 49:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 55:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 61:26 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 61:27 Transforming destructuring to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 29:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 30:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 30:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 31:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 31:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 35:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 41:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 47:26 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 47:27 Transforming destructuring to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 15:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 16:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 19:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 21:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 27:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 33:26 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 33:27 Transforming destructuring to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { Core } = await importModule('Core');
    const { $classListTemp, $toggleDisplay } = await importModule('Utils');

    const CN_ANIMATE = '!animate';

    customElements.define('cart-counter', class extends Core {

        subscriptions = {
            'cart:update': '_cartUpdateHandler'
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            this.publish('cart:add-feature', { feature: 'counter' });
            this.subscribe('cart:update', { global: true });
        }

        _cartUpdateHandler({ meta }) {
            this.items = meta.count;
            $classListTemp(this, CN_ANIMATE);
        }

        set items(value) {
            this.textContent = value;
            $toggleDisplay(this, !!value);
        }
        
    })
})();